import React from 'react';
import { FileText, Edit, X } from 'lucide-react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';

const ProviderNotesSection = ({ editedData, isEditing, onToggleEdit, onCancelEdit, onUpdateField }) => {
  return (
    <div className="mb-6">
      <div className="card border-2 border-teal-200 bg-gradient-to-br from-white to-teal-50 shadow-lg">
        <div className="flex items-center justify-between mb-4 pb-2 border-b-2 border-teal-100">
          <h2 className="text-xl font-semibold text-slate-900 flex items-center gap-2">
            <FileText size={20} className="text-teal-600" />
            Provider Notes (Hidden from Patient)
          </h2>
          {!isEditing ? (
            <Button onClick={onToggleEdit} className="btn-secondary" data-testid="provider-notes-edit-btn">
              <Edit size={16} className="mr-2" />
              Edit
            </Button>
          ) : (
            <Button onClick={onCancelEdit} className="btn-ghost text-red-600" data-testid="provider-notes-cancel-btn">
              <X size={16} className="mr-2" />
              Cancel
            </Button>
          )}
        </div>

        {!isEditing ? (
          <div className="p-4 bg-white rounded-lg border border-teal-200">
            {editedData.health_record?.provider_notes ? (
              <p className="text-slate-700 whitespace-pre-wrap">{editedData.health_record.provider_notes}</p>
            ) : (
              <p className="text-slate-500 italic">No provider notes</p>
            )}
          </div>
        ) : (
          <Textarea
            value={editedData.health_record?.provider_notes || ''}
            onChange={(e) => onUpdateField('health_record', 'provider_notes', e.target.value)}
            className="w-full"
            rows={8}
            placeholder="Enter private provider notes (these are not visible to the patient)..."
            data-testid="provider-notes-textarea"
          />
        )}
      </div>
    </div>
  );
};

export default ProviderNotesSection;
